import { useContext, useState } from 'react';
import { UserContext } from '../context/UserContext';
import API from '../config/axiosConfig';
import { acquireMfaToken } from '../auth/runtimeAuth';

// Turning two-step verification on or off for the user's own Microsoft account.
// Shared by the "אימות דו-שלבי" switch and the security shield's "upgrade" to gold,
// so both run the same process. See docs/Authentication.md (Two-step verification).
export const useTwoStepVerification = () => {
  const { refreshUserData } = useContext(UserContext);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');

  const change = async (enabled) => {
    setIsSaving(true);
    setError('');
    try {
      // Turning it off needs a token that already proved MFA. An opted-in user's
      // session always has one, so in practice no code is asked for here; only a
      // token without it gets mfa_required, which the API client answers by
      // asking Microsoft for the code and retrying. Asking again at this point is
      // a known gap, B17 in docs/Cloud-Committee-Readiness.md.
      await API.put('/api/users/me/mfa', { enabled }, { handlingErrorLocally: true });
      if (enabled) {
        // Ask for the code right away, so the user sees it work. Returns null
        // while the page leaves for Microsoft's code page.
        const token = await acquireMfaToken({ returnTo: '/profile' });
        if (!token) return;
      }
      await refreshUserData();
    } catch (requestError) {
      setError(
        requestError.serverError?.hebMessage
        || 'לא הצלחנו לעדכן את האימות הדו-שלבי. נסו שוב.'
      );
    } finally {
      setIsSaving(false);
    }
  };

  return { change, isSaving, error };
};
